import React from 'react';
import { Helmet } from 'react-helmet';
import Results from '../../components/Results';
import {
  FLIGHT_SEARCH_TYPE,
  SESSION_STORAGE_LAST_RETURN_FLIGHT_RESULTS,
} from '../../utils/constants';
import withResults from '../../utils/hocComponent';
import Dictionary from '../../utils/dictionary';
import useDictionary from '../../hooks/useDictionary';
import { getSessionStorageItem } from '../../operations/sessionStorage/utils';
import setSearchResults from '../../operations/localState/setSearchResults';
import { shouldSearchReturnResultsVar } from '../../operations/localState/reactiveVariables';

const ReturnFlights = withResults(Results, FLIGHT_SEARCH_TYPE.RETURN);

const ResultsReturn = () => {
  const getDictionary = useDictionary(Dictionary);

  if (!shouldSearchReturnResultsVar()) {
    const lastDepartureFlightResults = getSessionStorageItem(
      SESSION_STORAGE_LAST_RETURN_FLIGHT_RESULTS,
    );
    if (lastDepartureFlightResults && lastDepartureFlightResults.matchingFlights) {
      setSearchResults(lastDepartureFlightResults);
    }
  }

  return (
    <>
      <Helmet>
        <title>{getDictionary(Dictionary.airResultsReturnSeoTitle.key)}</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <ReturnFlights />;
    </>
  );
};

export default ResultsReturn;
